export default __webpack_public_path__ + "static/media/stm fikt.48e20f7b.png";